import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actionGroup", "hideRetry", "retry", "position", "testId", "title", "icon", "hideIcon"];
import React from 'react';
import { InternalActionName, SmartLinkAlignment } from '../../../../../../constants';
import { useFlexibleUiContext } from '../../../../../../state/flexible-ui-context';
import { UnresolvedAction } from '../../../actions';
import { LinkIcon } from '../../../elements';
import Block from '../../block';
import ElementGroup from '../../element-group';
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */
var TitleBlockErroredView = function TitleBlockErroredView(_ref) {
  var _context$actions;
  var actionGroup = _ref.actionGroup,
    hideRetry = _ref.hideRetry,
    retry = _ref.retry,
    position = _ref.position,
    testId = _ref.testId,
    title = _ref.title,
    icon = _ref.icon,
    hideIcon = _ref.hideIcon,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleUiContext();
  var showRetry = !hideRetry && Boolean(context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[InternalActionName.UnresolvedAction]);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: "".concat(testId, "-errored-view")
  }), !hideIcon && /*#__PURE__*/React.createElement(LinkIcon, {
    overrideIcon: icon,
    position: position
  }), title, showRetry && /*#__PURE__*/React.createElement(ElementGroup, {
    align: SmartLinkAlignment.Right
  }, /*#__PURE__*/React.createElement(UnresolvedAction, {
    testId: testId
  })), actionGroup);
};
export default TitleBlockErroredView;